export const BANDS_WORKSPACE_APP_TABS = Object.freeze([
    { id: "chat" },
    { id: "files" },
    { id: "calendar" },
    { id: "tasks" },
]);

export const BANDS_WORKSPACE_APP_TAB_IDS = BANDS_WORKSPACE_APP_TABS.map((tab) => tab.id);

export const ORBIT_CALENDAR_VIEW_STORAGE_KEY = "muzone.bands.orbitPlanner.view";
export const DEFAULT_CALENDAR_VIEW = "timeGridWeek";
export const MONTH_CALENDAR_VIEW = "dayGridMonth";
export const BANDS_ACTIVE_APP_STORAGE_KEY = "muzone.bands.activeApp";
export const BANDS_COMMENT_PANEL_STORAGE_KEY = "muzone.bands.commentPanel";
export const BANDS_CALENDAR_RANGE_STORAGE_KEY = "muzone.bands.orbitPlanner.range";

export const EMPTY_COMMENT_PANEL_MEMORY = Object.freeze({
    open: false,
    scope: null,
    groupId: null,
    channelId: null,
    directChatId: null,
    messageId: null,
});
